import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { CategoryStore, CategoryActions, STATUS } from 'Stores/categoryStore'
import CategoryForm from 'Modules/category/categoryForm'

export default class CategoryCreate extends Component {
  constructor(props) {
    super(props)
    this.stores = [CategoryStore]
    this.storeKeys = ['loadingState']
  }
  componentDidMount() {
    CategoryActions.createEmptyCategory()
  }
  componentDidUpdate() {
    if (this.state.loadingState === STATUS.CATEGORY_FAILED) {
      toast.error('CREATE CATEGORY FAILED', {
        autoClose: 3000,
        onClose: () => {
          CategoryActions.clearToast()
        }
      })
      CategoryActions.clearToast()
    }
    if (this.state.loadingState === STATUS.CATEGORY_SUCCESS) {
      toast.success('CREATED CATEGORY SUCCESSFUL', {
        autoClose: 3000,
        onClose: () => {
          CategoryActions.clearToast()
        }
      })
      CategoryActions.clearToast(STATUS.IS_REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <CategoryForm />
      </React.Fragment>
    )
  }
}
